import React, { FC } from 'react';
import { Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import { NotificationsProvider } from '@mantine/notifications';

import { GlobalProvider, RepositoryProvider } from '@context';
import { CallbackPage, LocalSignUpPage, NotFoundPage, OnboardingProcessPage, LocalSignInPage } from '@pages';
import bgImage from '@assets/img/bg_onboarding_process.png';
import { PageWrapper } from '@components';
import { ProtectedRoute } from '@components/ProtectedRoute';
import { UnauthorizedRoute } from '@components/UnauthorizedRoute';
import AuthProvider from '@context/auth-provider';
import { I18nextProvider } from 'react-i18next';
import i18n from '@common/translations/i18n';

const queryClient = new QueryClient();

const App: FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <GlobalProvider>
        <NotificationsProvider position='top-right'>
          <AuthProvider>
            <RepositoryProvider>
              <I18nextProvider i18n={i18n}>

                <Routes>
                  <Route
                    path='/'
                    element={
                      <ProtectedRoute>
                        <PageWrapper bgImage={bgImage}>
                          <OnboardingProcessPage />
                        </PageWrapper>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path='/local-sign-up'
                    element={
                      <UnauthorizedRoute>
                        <PageWrapper bgImage={bgImage}>
                          <LocalSignUpPage />
                        </PageWrapper>
                      </UnauthorizedRoute>
                    }
                  />
                  <Route
                    path='/local-sign-in'
                    element={
                      <UnauthorizedRoute>
                        <PageWrapper bgImage={bgImage}>
                          <LocalSignInPage />
                        </PageWrapper>
                      </UnauthorizedRoute>
                    }
                  />
                  <Route path='callback/*' element={<CallbackPage />} />
                  <Route path='*' element={<NotFoundPage />} />
                </Routes>
                <ToastContainer />
              </I18nextProvider>
            </RepositoryProvider>
          </AuthProvider>
        </NotificationsProvider>
      </GlobalProvider>
    </QueryClientProvider>
  );
};

export default App;
